export type IssueStatus = "open" | "in_progress" | "resolved" | "wont_fix";
export type IssueCategory = "bug" | "performance" | "ux" | "feature" | "permissions" | "other";
export type IssuePriority = "low" | "medium" | "high" | "critical";

export const ISSUE_STATUS_LABELS: Record<IssueStatus, string> = {
  open: "Otwarte",
  in_progress: "W trakcie",
  resolved: "Rozwiązane",
  wont_fix: "Nie naprawiamy",
};

export const ISSUE_CATEGORY_LABELS: Record<IssueCategory, string> = {
  bug: "Błąd",
  performance: "Wydajność",
  ux: "UX / interfejs",
  feature: "Propozycja funkcji",
  permissions: "Przyznanie uprawnień",
  other: "Inne",
};

export const ISSUE_PRIORITY_LABELS: Record<IssuePriority, string> = {
  low: "Niski",
  medium: "Średni",
  high: "Wysoki",
  critical: "Krytyczny",
};

export interface IssueAttachment {
  id: string;
  original_name: string;
  url: string;
  /** ManagedFile id — the key to a FRESH download link (`url` is a presigned S3 link that expires). */
  managed_file: string | null;
  uploaded_by_name: string | null;
  created_at: string;
}

export interface IssueCommentMention {
  id: string;
  full_name: string;
}

export interface IssueParticipant {
  id: string;
  full_name: string;
}

export interface IssueComment {
  id: string;
  content: string;
  author_id: string | null;
  author_name: string;
  author_photo_url: string | null;
  is_developer_author: boolean;
  attachments: IssueAttachment[];
  mentions: IssueCommentMention[];
  created_at: string;
}

export interface TechnicalIssue {
  id: string;
  title: string;
  description: string;
  category: IssueCategory | null;
  priority: IssuePriority | null;
  status: IssueStatus;
  reporter_id: string | null;
  reporter_name: string | null;
  assignee_id: string | null;
  assignee_name: string | null;
  resolved_at: string | null;
  attachments: IssueAttachment[];
  comments_count: number;
  participants: IssueParticipant[];
  created_at: string;
  updated_at: string;
}
